export const SMS_TEMPLATE_TYPES = {
  // PENDING: {
  //   code: 100,
  //   template:
  //     "Shipment {shipmentId} is created. We'll notify you once processing begins.",
  //   variables: ["shipmentId"],
  // },
  // COLLECTED: {
  //   code: 101,
  //   template:
  //     "Shipment {shipmentId} collected. Now in transit to {destination}. Track: {trackingUrl}",
  //   variables: ["shipmentId", "destination", "trackingUrl"],
  // },
  // CONSOLIDATION: {
  //   code: 102,
  //   template:
  //     "Shipment {shipmentId} in consolidation at {facility}. Preparing for transit.",
  //   variables: ["shipmentId", "facility"],
  // },
  // LOADED: {
  //   code: 103,
  //   template:
  //     "Shipment {shipmentId} loaded for transit from {origin} to {destination}.",
  //   variables: ["shipmentId", "origin", "destination"],
  // },
  UNLOADED: {
    code: 104,
    template: "Shipment {shipmentId} unloaded at hub. Awaiting next steps.",
    variables: ["shipmentId"],
  },
  COLLECTED: {
    code: 110,
    template:
      "Shipment {shipmentId} has been collected from the sender. It will be delivered soon.",
    variables: ["shipmentId"],
  },
  FREELOADING: {
    code: 111,
    template:
      "Shipment {shipmentId} has been collected and loaded for transit. It is now on the way to the destination.",
    variables: ["shipmentId"],
  },

  // DECONSOLIDATION: {
  //   code: 105,
  //   template:
  //     "Deconsolidation started for Shipment {shipmentId} at {facility}.",
  //   variables: ["shipmentId", "facility"],
  // },
  // CROSS_DOCKED: {
  //   code: 106,
  //   template:
  //     "Shipment {shipmentId} cross-docked at {facility} for {destination}.",
  //   variables: ["shipmentId", "facility", "destination"],
  // },
  SEND_OUT: {
    code: 107,
    template: "Shipment {shipmentId} sent out for delivery by {user}",
    variables: ["shipmentId", "user"],
  },
  // WAREHOUSING: {
  //   code: 108,
  //   template:
  //     "Shipment {shipmentId} stored in warehouse at {facility}. Processing soon.",
  //   variables: ["shipmentId", "facility"],
  // },
  DELIVERED: {
    code: 109,
    template: "Shipment {shipmentId} delivered to the destination. Thank you!",
    variables: ["shipmentId"],
  },
  // DELIVERY_FAILED: {
  //   code: 110,
  //   template:
  //     "Delivery failed for Shipment {shipmentId}. Reason: {reason}. Contact us.",
  //   variables: ["shipmentId", "reason"],
  // },
  // RETURN: {
  //   code: 111,
  //   template:
  //     "Return initiated for Shipment {shipmentId}. Returning to {sender}.",
  //   variables: ["shipmentId", "sender"],
  // },
  // CANCELLED: {
  //   code: 112,
  //   template: "Shipment {shipmentId} cancelled. Contact support for details.",
  //   variables: ["shipmentId"],
  // },
  // PAID: {
  //   code: 113,
  //   template:
  //     "Payment received for Shipment {shipmentId}. Amount: {amount}. Thank you!",
  //   variables: ["shipmentId", "amount"],
  // },
  // TRANSFERRED: {
  //   code: 114,
  //   template:
  //     "Payment for Shipment {shipmentId} transferred to vendor. Amount: {amount}.",
  //   variables: ["shipmentId", "amount"],
  // },

  COD_TRANSFER_COMPLETED: {
    code: 202,
    template:
      "COD Transfer {codTransferId} completed successfully. Amount {amount} has been transferred to your account.",
    variables: ["codTransferId", "amount"],
  },

  COD_TRANSFER_FAILED: {
    code: 203,
    template:
      "COD Transfer {codTransferId} failed. Reason: {reason}. Please contact support.",
    variables: ["codTransferId", "reason"],
  },
};

export const processID = [
  // 100, 101, 102, 103,
  104,
  // 105, 106,
  107,
  // 108,
  109, 110, 111,
  // 112, 113, 114,
  202, 203,
];

export const getTemplateByCode = (code) => {
  return Object.values(SMS_TEMPLATE_TYPES).find(
    (template) => template.code === code
  );
};
export const getTemplateOptions = () =>
  Object.entries(SMS_TEMPLATE_TYPES).map(([key, val]) => ({
    label: `Process ${val.code}-${val.label || key} `,
    value: val.code,
  }));

export const getAllTemplateCodes = () => {
  return Object.values(SMS_TEMPLATE_TYPES).map((template) => template.code);
};
